import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { PersonalCertSection } from './PersonalCertSection';
import { EnterpriseCertSection } from './EnterpriseCertSection';

interface CertificationSectionProps {
  className?: string;
}

export const CertificationSection: React.FC<CertificationSectionProps> = ({ className = '' }) => {
  const { user, rawUser } = useAuth();
  const accountType = (rawUser?.account_type || user?.accountType || '').toUpperCase();
  const isEnterpriseAccount = accountType === 'ENTERPRISE';

  return (
    <div className={`glass-card rounded-2xl p-6 md:p-8 mb-6 ${className}`}>
      {/* 根据当前账号类型，只展示对应账户类型的认证模块 */}
      {isEnterpriseAccount ? <EnterpriseCertSection /> : <PersonalCertSection />}
    </div>
  );
};

export default CertificationSection;
